<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Gerenciamento Usuários</div>
</div>

<mat-tab-group animationDuration="400ms">
  @if (checkPermission('paginado', 'legal')) {
    <mat-tab label="Funcionário" [disabled]="!checkPermission('paginado', 'legal')">
      <!--  <mat-tab label="Jurídico">-->
      <employee-management></employee-management>
    </mat-tab>
  }
  <!--  <mat-tab label="Fisico" disabled>-->
  <!--    <individual-client></individual-client>-->
  <!--  </mat-tab>-->
  @if (checkPermission('paginado', 'sub')) {
    <mat-tab
      label="Motorista"
      [disabled]="!checkPermission('paginado', 'sub')"
    >
      <driver-management></driver-management>
    </mat-tab>
  }
  @if (checkPermission('paginado', 'consultant')) {
    <mat-tab
      label="Fornecedor"
      [disabled]="!checkPermission('paginado', 'consultant')"
    >
      <supplier-management></supplier-management>
    </mat-tab>
  }
</mat-tab-group>
